import * as z from 'zod';

const PlayerPositionSchema = z.enum(['forward', 'defender', 'midfielder', 'goalkeeper']);

const BasePlayerDataSchema = z.object({
  name: z.string(),
  position: PlayerPositionSchema.nullable(),
  flag: z.string().nullable(),
});

export const GoalsPlayerDataSchema = BasePlayerDataSchema.extend({
  goals: z.number(),
});

export const AssistsPlayerDataSchema = BasePlayerDataSchema.extend({
  assists: z.number(),
});

export const ShotsPlayerDataSchema = BasePlayerDataSchema.extend({
  shotsOnTarget: z.number(),
  shotsOffTarget: z.number(),
});

export const CardsPlayerDataSchema = BasePlayerDataSchema.extend({
  yellowCards: z.number(),
  redCards: z.number(),
});

export const InjuriesPlayerDataSchema = BasePlayerDataSchema.extend({
  status: z.enum(['missing', 'doubtful']),
});

const TeamPlayersDataSchema = z.object({
  goals: z.array(GoalsPlayerDataSchema),
  assists: z.array(AssistsPlayerDataSchema),
  shots: z.array(ShotsPlayerDataSchema),
  cards: z.array(CardsPlayerDataSchema),
  injuries: z.array(InjuriesPlayerDataSchema),
});

const PlayersTabResponseSchema = z.object({
  home: TeamPlayersDataSchema,
  away: TeamPlayersDataSchema,
});

export default PlayersTabResponseSchema;
